import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text/text';
import {KeyKind, type ShortcutKey} from '@FormMakerReact/layout/form-maker-right-panel/views/keyboard-shortcuts-view/keyboard-shortcuts-view.types';
import type {ShortcutRowProps} from './shortcut-row.types';
import styles from './shortcut-row.module.scss';

export function ShortcutRow({label, keys}: ShortcutRowProps): ReactElement {
  return (
    <div className={styles.row}>
      <Text val={label} size={TextSize.MD} className={styles.label} />
      <div className={styles.keys}>{keys.map(renderKeyWithSeparator)}</div>
    </div>
  );
}

function renderKeyWithSeparator(key: ShortcutKey, idx: number): ReactElement {
  return (
    <React.Fragment key={idx}>
      {renderPlusBeforeFirstKey(idx)}
      {renderKeyBox(key)}
    </React.Fragment>
  );
}

function renderPlusBeforeFirstKey(idx: number): ReactElement | null {
  if (idx === 0) {
    return null;
  }
  return <Icon icon="icon-plus" size={IconSize.SIZE_ICON_16} className={styles.plus} />;
}

function renderKeyBox(key: ShortcutKey): ReactElement {
  const className = key.kind === KeyKind.CHAR ? styles.charBox : styles.stringBox;
  return <span className={className}>{key.display}</span>;
}
